import { Directive } from '@angular/core';

@Directive({
  selector: '[hdUploadImage]'
})
export class UploadImageDirective {

  constructor() { }

}
